// eslint-disable-next-line no-unused-vars
import TimesheetsPendingApprovalViewModel from './timesheetsPendingApprovalViewModel'

export default class TimesheetsPendingApprovalMainListItem {
  constructor(params) {
    /**
     * Actual data of timesheet
     * @type {TimesheetsPendingApprovalViewModel}
     */
    this.timesheet = params.timesheet
    /**
     * Reference to client displayable for
     * processing update/cleanup after submission
     */
    this.refToClientDisplayable = params.refToClientDisplayable
    /**
     * Reference to client displayable's week group array for
     * processing update/cleanup after submission
     */
    this.refToClientWeekGroup = params.refToClientWeekGroup
    /**
     * Reference to client displayable's leaf group (candidate)
     * for processing cleanup after submission
     */
    this.refToClientDictionaryValueArray =
      params.refToClientDictionaryValueArray
    /**
     * Reference to candidate displayable for
     * processing update/cleanup after submission
     */
    this.refToCandidateDisplayable = params.refToCandidateDisplayable
    /**
     * Reference to candidate displayable's week group array for
     * processing update/cleanup after submission
     */
    this.refToCandidateWeekGroup = params.refToCandidateWeekGroup
    /**
     * Reference to candidate displayable's leaf group (client)
     * for processing cleanup after submission
     */
    this.refToCandidateDictionaryValueArray =
      params.refToCandidateDictionaryValueArray
  }
}
